// import React from 'react'
import emailjs from "@emailjs/browser";
import { motion } from "framer-motion";
import { useState } from "react";
import { Button, Input, Textarea } from "@material-tailwind/react";
import { FiPhone, FiMapPin, FiMail } from "react-icons/fi";
import { MdDoorBack, MdRocketLaunch } from "react-icons/md";

const contacts = [
  {
    id: 1,
    name: "Chaitanyapur-Haldia,West Bengal India-721658",
    icon: <FiMapPin />,
  },
  {
    id: 2,
    name: "sastikkumardas@gmail.com",
    icon: <FiMail />,
  },
  {
    id: 3,
    name: "+91 9679482955",
    icon: <FiPhone />,
  },
];

const Contact = () => {
  const [message, setMessage] = useState(false);
  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_xs9cwvf",
        "template_01cn0ji",
        e.target,
        "70f8P4IUl2wBty9HZ"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
    setMessage(true);
  };
  return (
    <section
      id="contact"
      className="md:min-h-[84vh] w-full flex flex-col items-center"
    >
      <div className="flex flex-col md:flex-row items-center justify-center lg:mx-72">
        <motion.div
          initial={{ opacity: 0, x: 100 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="lg:w-[400px] "
        >
          <div className="w-full">
            <div className="text-left max-w-xl px-4">
              <h2 className="font-semibold  text-2xl text-primary-dark mt-12 mb-8">
                Contact details
              </h2>
              <ul className="font-general-regular font-serif text-sm px-4">
                {contacts.map((contact) => (
                  <li className="flex flex-row items-start" key={contact.id}>
                    <i className="text-2xl text-gray-500 mr-4 animate-pulse">
                      {contact.icon}
                    </i>
                    <span className="text-lg mb-4 text-ternary-dark ">
                      {contact.name}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: -100 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="w-[100%]  lg:w-[500px] "
        >
          {!message ? (
            <div className="relative m-5 rounded-lg bg-white p-8 shadow-lg hover:shadow-2xl sm:p-12">
              <form onSubmit={sendEmail}>
                <div className="mb-6 ">
                  <Input
                    type="text"
                    name="name"
                    label="Enter Your Name"
                    required
                  />
                </div>
                <div className="mb-6">
                  <Input
                    type="email"
                    name="email"
                    label="Enter Your Email"
                    required
                  />
                </div>
                <div className="mb-6">
                  <Input type="text" name="subject" label="Subject" required />
                </div>
                <div className="mb-6">
                  <Textarea
                    rows="6"
                    name="message"
                    label="Enter Message"
                    required
                  />
                </div>
                <div>
                  <Button
                    variant="gradient"
                    type="submit"
                    className="mt-5 flex items-center gap-3"
                  >
                    <MdRocketLaunch className="text-white text-lg animate-bounce" />
                    Send Message
                  </Button>
                </div>
              </form>
            </div>
          ) : (
            <div class="relative m-6 rounded-lg bg-white p-2 shadow-lg hover:shadow-2xl sm:p-4">
              <svg
                viewBox="0 0 24 24"
                class="text-blue-600 w-16 h-16 mx-auto my-6"
              >
                <path
                  fill="currentColor"
                  d="M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
                ></path>
              </svg>
              <div class="text-center">
                <h3 class="md:text-xl text-base text-gray-900 font-semibold text-center">
                  Successfully Sent!
                </h3>
                <p class="text-gray-600 my-4 ">
                  Thank you for reaching out! Your message has been received
                  successfully. I appreciate you contacting me and will review
                  your message promptly. Expect to hear back from me soon with
                  feedback.
                </p>
                <p> Have a great day! </p>
                <div class="py-2 text-center flex justify-center">
                  <Button
                    variant="gradient"
                    onClick={() => setMessage(!message)}
                    className="mt-5 flex items-center gap-3"
                  >
                    <MdDoorBack className="text-white text-lg animate-bounce" />
                    Go Back
                  </Button>
                </div>
              </div>
            </div>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
